import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { createWithLoadingButton } from '$common/buttons/with-loading-button'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary500}`,
  backgroundColor: theme.palette.white,
  color: theme.palette.primary500,
  '&:hover': {
    backgroundColor: theme.palette.neutral000,
  },
  '&.Mui-disabled': {
    backgroundColor: `${theme.palette.neutral000} !important`,
  },
  '& .MuiButton-endIcon': {
    margin: 0,
    '& > svg': {
      fontSize: '24px',
    },
  },
}))

export const PrimaryOutlinedButton = createWithLoadingButton(StyledButton)
